import { module as modujs } from "modujs";
import { gsap } from "gsap";

// Function to create a slug from a string
function slugify(text) {
	return text
		.toString()
		.toLowerCase()
		.trim()
		.replace(/\s+/g, "-") // Replace spaces with -
		.replace(/[^\w-]+/g, "") // Remove all non-word chars
		.replace(/--+/g, "-") // Replace multiple - with single -
		.replace(/^-+/, "") // Trim - from start of text
		.replace(/-+$/, ""); // Trim - from end of text
}

export default class extends modujs {
	constructor(m) {
		super(m);

		// this.events = {
		//  click: {
		//      link: "click",
		//  },
		// };
	}

	init() {
		this.$content = this.$("content");
		this.$nav = this.$("nav")[0];
		this.$sections = this.$("section");
		let href = [];

		this.$sections.forEach(($section) => {
			let $titles = $section.querySelectorAll("h2");

			$titles.forEach(($title) => {
				const slug = slugify($title.textContent.trim());
				$section.id = slug; // Set the ID of the section
				href.push({
					title: $title.textContent.trim(),
					url: `#${slug}`,
				});
			});
		});

		href.forEach((item) => {
			const linkElement = document.createElement("a");
			linkElement.href = item.url;
			linkElement.classList.add("o-single_table_item");
			linkElement.innerHTML = `
                <span class="o-single_table_item_title || o-typography -label-small">
                    <i class="o-icon -shapes-3 -s150 -tertiary-300"></i>
                    ${item.title}
                </span>
            `;
			this.$nav.appendChild(linkElement);
		});
	}

	click() {}
}
